<script>
  export let idUnico = 'legislacao-1';
  export let content;
  import { onMount } from 'svelte';
  import { location } from 'svelte-spa-router';

  let spaceIndex;
  let apresentacao = false;

  if ($location === '/' || Number($location.split('/')[1]) === 1) {
    apresentacao = true;
  }

  onMount(() => {
    content = toItalic(content);
    content = content.trim();
    spaceIndex = content.indexOf(' ');
  });
</script>

<div class="container {apresentacao ? '' : 'titulo'}" id={idUnico}>
  <h3 class="titulo {apresentacao ? 'menor' : ''}">
    <span>{@html content.substring(0, spaceIndex)}</span>
    {@html content.substring(spaceIndex + 1)}
  </h3>
</div>

<style>
  .container.titulo {
    margin: 3rem auto -0.5rem auto;
  }
  :global(h3.menor) {
    color: var(--VERDE);
    font-size: 20px;
    font-weight: 500;
    font-family: var(--FONT_LORA);
    margin-bottom: -1.2rem;
    margin-top: 3.5rem;
  }
  @media (max-width: 767px) {
    :global(h3.menor) {
      font-size: 20px;
    }
  }
</style>
